<template>
  <div>
    <div>
      <div class="am-dialog-header">
        <span>Payment Details</span>
      </div>
      <div class="am-payment-details-table">
        <div class="am-payment-details-left-columns">
          <table>
            <tbody>
            <tr>
              <strong><span>Finance Company:</span></strong>
              <td>{{paymentDetails.financeCompanyName}}</td>
            </tr>
            <tr>
              <strong><span>Contract Number:</span></strong>
              <td>{{paymentDetails.contractNumber}}</td>
            </tr>
            <tr>
              <strong><span>Contract Status:</span></strong>
              <td v-if="paymentDetails.List">{{paymentDetails.List.contract_status}}</td>
            </tr>
            <tr>
              <strong><span>Payment Remaining:</span></strong>
              <td v-if="paymentDetails.List">{{paymentDetails.List.payment_remaining}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="am-payment-details-right-columns">
          <table>
            <tbody>
            <tr>
              <strong><span>Amount Due:</span></strong>
              <td v-if="paymentDetails.List">${{paymentDetails.List.AmountDue}}</td>
            </tr>
            <tr>
              <strong><span>Amount Due Date:</span></strong>
              <td v-if="paymentDetails.List">{{paymentDetails.List.DateAmountDue | moment("MM/DD/YYYY")}}</td>
            </tr>
            <tr>
              <strong><span>Pay Off Amount:</span></strong>
              <td v-if="paymentDetails.List">${{paymentDetails.List.payoff_amount}}</td>
            </tr>
            <tr>
              <strong><span>Pay Off Date:</span></strong>
              <td v-if="paymentDetails.List">{{paymentDetails.List.payoff_date | moment("MM/DD/YYYY")}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="am-finance-main-table">
        <table class="am-finance-table" v-if="paymentDetails.History != null">
          <thead>
          <tr>
            <th class="am-text-align-left">Date</th>
            <th class="am-text-align-left">Description</th>
            <th class="am-text-align-right">Amount</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="history in paymentDetails.History">
            <td class="am-text-align-left">{{history.Trans_date | moment("MM/DD/YYYY")}}</td>
            <td class="am-text-align-left">{{history.transdesc1}}</td>
            <td class="am-text-align-right am-negative-amount" v-if="history.TransSign === 'N'">(${{history.trans_amt}})</td>
            <td class="am-text-align-right" v-else>${{history.trans_amt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="am-blue-border"></div>
      <div class="am-buttons-payment-details">
        <button type="button" class="btn btn-primary btn-xs" title="Pay in Full" @click="submitPayment('full')">Pay in Full</button>
        <button type="button" class="btn btn-primary btn-xs" title="Pay in Installments" @click="submitPayment('installment')">Installment Payment</button>
        <button type="button" class="btn btn-secondary btn-xs" title="Cancel" @click="closeDialog()">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "PaymentDetails",
        data: function () {
            return {
            paymentDetails: [
                {
                    financeCompanyName: '',
                    dateFinanced: '',
                    contractNumber: '',
                    fundingStatus: '',
                    List: {
                        contract_status: '',
                        AmountDue: '',
                        payoff_amount: '',
                        DateAmountDue: '',
                        payment_remaining: '',
                        payoff_date: ''
                    },
                    History: [{
                        Trans_date : '',
                        TransSign : '',
                        trans_amt: ''
                    }]
                }
            ]
        }
        },

        props: {
            financeId: Number,
            paymentDetails: Object,
            policyItems: Object
        },
        methods: {
            closeDialog() {
                this.$modal.hide('paymentDetails')
            },
            getPolicyIds() {
                let ids = '';
                this.policyItems.forEach(policy => {
                    ids = policy.id + ',' + ids
                })
                return ids.slice(0,ids.length-1);
            },
            submitPayment (type) {
                this.closeDialog()
                let paymentAppendage = this.paymentDetails.fundingStatus === "Partial Funded" ? "MPP" : "MPF";
                window.location.href = '/customersPayment.php?id=' + this.policyItems[0].custid + '&items=' + this.getPolicyIds() + '&financeAmount=' + (type === 'full' ? this.paymentDetails.List.payoff_amount : this.paymentDetails.List.AmountDue) + '&isPremiumFinance=true&isFinancePayment=true&paymentAppendage=' + paymentAppendage
            }

        }
    }
</script>

<style scoped>
  .am-dialog-header {
    height: 35px;
    background-color: #428bca;
    padding: 10px;
    top: 0;
    color: white;
    font-weight: 700;
  }

  .am-text-align-left {
    text-align: left;
  }

  .am-text-align-right {
    text-align: right;
  }

  .am-finance-main-table {
    padding: 15px;
  }

  .am-finance-table {
    width: 100%;
    padding: 10px;
  }

  .am-finance-table tbody tr:nth-child(odd) {
    background-color: #ECECEC;
  }

  .am-finance-table tbody tr:nth-child(even) {
    background-color: #F4F4F4;
  }

  .am-finance-table thead {
    background-color: black;
    color: white;
    display: table;
    width: calc(100% - 13px);
  }
  .am-finance-table td, .am-finance-table th {
    font-size: 11px;
    width: 40px;
    word-break: break-all;
  }

  .am-finance-table tr {
    display: table;
    width: 100%;
  }

  .am-finance-table tbody {
    display:block;
    overflow-y:scroll;
    max-height:220px;
  }

  .am-payment-details-table {
    padding: 10px 0px 60px 8px;
  }

  .am-payment-details-table td {
    padding: 0px 5px 0px 5px;
  }

  .am-buttons-payment-details {
    width: 100%;
    bottom: 0;
    padding: 5px 7px 10px 230px;
  }

  .am-buttons-payment-details button {
    margin-left: 5px;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 10px;
  }

  .am-negative-amount {
    color: red;
  }

  .am-payment-details-left-columns {
    float: left;
    padding-left: 10px
  }
  .am-payment-details-right-columns {
    float: right;
    padding-right: 20px
  }
</style>
